const downloadFile = (file: Blob | File | string, filename: string) => {
  if (window.navigator.msSaveOrOpenBlob) { // IE10+
    if (typeof file !== 'string') {
      window.navigator.msSaveOrOpenBlob(file, filename);
    }
  } else { // Others
    const a = document.createElement('a');
    const url = typeof file !== 'string' ? URL.createObjectURL(file) : file;
    a.href = url;
    a.download = filename;
    a.target = '_blank';
    document.body.appendChild(a);
    a.click();
    setTimeout(() => {
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }, 0);
  }
};

export default downloadFile;
